export default {
    translations: {
        addToCart: {
          // form blocked message
          "en": "Add to Cart",
          "en-gb": "Add to Cart",
          "en-us": "Add to Cart",
          "en_US": "Add to Cart",
          "en-eu": "Add to Cart",
          "en-zz": "Add to Cart",
          "en-in": "Add to Cart",
          "en-au": "Add to Cart",
          "de-de": "IN DEN EINKAUFSWAGEN",
          "fr-fr": "AJOUTER AU PANIER",
          "it-it": "AGGIUNGI AL CARRELLO",
          "es-es": "AÑADIR AL CARRO",
          "pl-pl": "DODAJ DO KOSZYKA",
          "ru-ru": "ДОБАВИТЬ В КОРЗИНУ",
          "cs-cz": "PŘIDAT DO KOŠÍKU",
          "da-dk": "FØJ TIL INDKØBSKURV",
          "de-at": "IN DEN EINKAUFSWAGEN",
          "fi-fi": "LISÄÄ OSTOSKORIIN",
          "fr-be": "AJOUTER AU PANIER",
          "nb-no": "LEGG TIL HANDLEVOGN",
          "nl-nl": "TOEVOEGEN AAN WINKELWAGEN",
          "sv-se": "LÄGG I KUNDVAGN",
          "pt-pt": "Acrescentar ao carrinho",
        },
        buyNow: {
          // form blocked message
          "en": "Buy Now",
          "en-gb": "Buy Now",
          "en-us": "Buy Now",
          "en_US": "Buy Now",
          "en-eu": "Buy Now",
          "en-zz": "Buy Now",
          "en-in": "Buy Now",
          "en-au": "Buy Now",
          "de-de": "KAUFEN SIE JETZT",
          "fr-fr": "ACHETER MAINTENANT",  
          "it-it": "COMPRA ORA",
          "es-es": "COMPRAR AHORA",
          "pl-pl": "KUP TERAZ",
          "ru-ru": "КУПИТЬ СЕЙЧАС",
          "cs-cz": "KUPIT SEČAS",
          "da-dk": "KØB NU",
          "de-at": "KAUFEN SIE JETZT",
          "fi-fi": "OSTA KAUFAA NOW",
          "fr-be": "KOMMANDERER MAINTENANT",
          "nb-no": "KJØP NÅ",
          "nl-nl": "KOPEN NU",
          "sv-se": "KÖP NU",
          "pt-pt": "COMPRAR AGORA",
        },
        outOfStock: {
          "en": "Out of Stock",
          "en-gb": "Out of Stock",
          "en-us": "Out of Stock",
          "en_US": "Out of Stock",
          "en-zz": "Out of Stock",
          "en-in": "Out of Stock",
          "en-au": "Out of Stock",
          "de-de": "DERZEIT NICHT VERFÜGBAR",
          "fr-fr": "RUPTURE DE STOCK",
          "it-it": "PRODOTTO ESAURITO",
          "es-es": "AGOTADO",
          "pl-pl": "TOWAR WYPRZEDANY",
          "ru-ru": "НЕТ В НАЛИЧИИ",
          "cs-cz": "NENÍ NA SKLADĚ",
          "da-dk": "UDSOLGT",
          "de-at": "DERZEIT NICHT VERFÜGBAR",
          "fi-fi": "LOPPUNUT",
          "fr-be": "RUPTURE DE STOCK",
          "nb-no": "TOMT PÅ LAGER",
          "nl-nl": "NIET OP VOORRAAD",
          "sv-se": "EJ I LAGER",
          "pt-pt": "Esgotado",
        },
        preOrder: {
          "en": "Pre Order",
          "en-gb": "Pre Order",
          "en-us": "Pre Order",
          "en_US": "Pre Order",
          "en-zz": "Pre Order",
          "de-de": "VORBESTELLEN",
          "fr-fr": "PRÉCOMMANDER",
          "it-it": "PRE-ORDINA",
          "es-es": "RESERVAR PEDIDO",
          "pl-pl": "ZAMÓW W PRZEDSPRZEDAŻY",
          "ru-ru": "ПРЕДЗАКАЗ",
          "cs-cz": "PŘEDOBJEDNAT",
          "da-dk": "FORUDBESTILLING",
          "de-at": "VORBESTELLEN",
          "fi-fi": "ENNAKKOTILAA",
          "fr-be": "PRÉCOMMANDER",
          "nb-no": "FORHÅNDSBESTILL",
          "nl-nl": "VOORAF BESTELLEN",
          "sv-se": "FÖRBESTÄLL",
          "pt-pt": "Pré-encomendar",
        },
        backOrder: {
          "en": "Add to Cart",
          "en-gb": "Add to Cart",
          "en-us": "Add to Cart",
          "en_US": "Add to Cart",
          "en-eu": "Add to Cart",
          "en-zz": "Add to Cart",
          "en-in": "Add to Cart",
          "en-au": "Add to Cart",
          "de-de": "IN DEN EINKAUFSWAGEN",
          "fr-fr": "AJOUTER AU PANIER",
          "it-it": "AGGIUNGI AL CARRELLO",
          "es-es": "AÑADIR AL CARRO",
          "pl-pl": "DODAJ DO KOSZYKA",
          "ru-ru": "ДОБАВИТЬ В КОРЗИНУ",
          "cs-cz": "PŘIDAT DO KOŠÍKU",
          "da-dk": "FØJ TIL INDKØBSKURV",
          "de-at": "IN DEN EINKAUFSWAGEN",
          "fi-fi": "LISÄÄ OSTOSKORIIN",
          "fr-be": "AJOUTER AU PANIER",
          "nb-no": "LEGG TIL HANDLEVOGN",
          "nl-nl": "TOEVOEGEN AAN WINKELWAGEN",
          "sv-se": "LÄGG I KUNDVAGN",
          "pt-pt": "Acrescentar ao carrinho",
        },
        notifyMe: {
          "en": "Notify Me",
          "en-gb": "Notify Me",
          "en-us": "Notify Me",
          "en_US": "Notify Me",
          "en-eu": "Notify Me",
          "en-zz": "Notify Me",
          "en-in": "Notify Me",
          "en-au": "Notify Me",
          "de-de": "BENACHRICHTIGUNGEN",
          "fr-fr": "NOTIFICATIONS",
          "it-it": "INVIA NOTIFICA",
          "es-es": "RECIBIR NOTIFICACIÓN",
          "pl-pl": "POWIADOM MNIE",
          "ru-ru": "СООБЩИТЕ МНЕ",
          "cs-cz": "UPOZORNIT",
          "da-dk": "GIV MIG BESKED",
          "de-at": "BENACHRICHTIGUNGEN",
          "fi-fi": "ILMOITA MINULLE",
          "fr-be": "NOTIFICATIONS",
          "nb-no": "SEND MEG VARSEL",
          "nl-nl": "GEEF MIJ EEN MELDING",
          "sv-se": "MEDDELA MIG",
          "pt-pt": "Notificar-me",
        },
        checkOut: {
          "en": "Checkout",
          "en-gb": "Checkout",
          "en-us": "Checkout",
          "en_US": "Checkout",
          "en-eu": "Checkout",
          "en-zz": "Checkout",
          "en-in": "Checkout",
          "en-au": "Checkout",
          "de-de": "ZUR KASSE",
          "fr-fr": "COMMANDER",
          "it-it": "PROCEDI ALL'ACQUISTO",
          "es-es": "DATOS DEL PEDIDO",
          "pl-pl": "ZŁÓŻ ZAMÓWIENIE",
          "ru-ru": "ОФОРМИТЬ ЗАКАЗ",
          "cs-cz": "POKLADNA",
          "da-dk": "KASSE",
          "de-at": "ZUR KASSE",
          "fi-fi": "KASSA",
          "fr-be": "COMMANDER",
          "nb-no": "GÅ TIL KASSEN",
          "nl-nl": "AFREKENEN",
          "sv-se": "GÅ TILL KASSAN",
          "pt-pt": "Finalizar",
        },
        checkingOut: {
          "en": "Checking Out...",
          "en-gb": "Checking Out...",
          "en-us": "Checking Out...",
          "en_US": "Checking Out...",
          "en-eu": "Checking Out...",
          "en-zz": "Checking Out...",
          "en-in": "Checking Out...",
          "en-au": "Checking Out...",
          "de-de": "ZUR KASSE GEHEN...",
          "fr-fr": "PAIEMENT...",
          "it-it": "PAGAMENTO...",
          "es-es": "PAGO...",
          "pl-pl": "SKŁADANIE ZAMÓWIENIA...",
          "ru-ru": "подготовка заказа...",
          "cs-cz": "PLACENÍ...",
          "da-dk": "BETALER...",
          "de-at": "ZUR KASSE GEHEN...",
          "fi-fi": "KASSALLA...",
          "fr-be": "PAIEMENT...",
          "nb-no": "FULLFØRER KJØP...",
          "nl-nl": "AFREKENEN...",
          "sv-se": "I KASSAN...",
          "pt-pt": "A finalizar...",
        },
        cartIsEmpty: {
          "en": "Your cart is empty.",
          "en-gb": "Your cart is empty.",
          "en-us": "Your cart is empty.",
          "en_US": "Your cart is empty.",
          "en-eu": "Your cart is empty.",
          "en-zz": "Your cart is empty.",
          "en-in": "Your cart is empty.",
          "en-au": "Your cart is empty.",
          "de-de": "Dein Einkaufswagen ist leer.",
          "fr-fr": "Votre panier est vide.",
          "it-it": "Il carrello è vuoto.",
          "es-es": "El carro está vacío.",
          "pl-pl": "Twój koszyk jest pusty.",
          "ru-ru": "Ваша корзина пуста.",
          "cs-cz": "Tvůj košík je prázdný.",
          "da-dk": "Din indkøbskurv er tom.",
          "de-at": "Dein Einkaufswagen ist leer.",
          "fi-fi": "Ostoskori on tyhjä.",
          "fr-be": "Votre panier est vide.",
          "nb-no": "Handlevognen er tom.",
          "nl-nl": "Je winkelwagen is leeg.",
          "sv-se": "Din varukorg är tom.",
          "pt-pt": "O carrinho está vazio.",
        },
        cartErrors: {
          "en": "Unable to process request, please try again later",
          "en-gb": "Unable to process request, please try again later",
          "en-us": "Unable to process request, please try again later",
          "en-eu": "Unable to process request, please try again later",
          "en-zz": "Unable to process request, please try again later",
          "en-in": "Unable to process request, please try again later",
          "en-au": "Unable to process request, please try again later",
          "de-de":
            "Die Anfrage kann nicht bearbeitet werden. Bitte versuche es später noch einmal.",
          "fr-fr":
            "Impossible de traiter la demande. Veuillez réessayer plus tard.",
          "it-it": "Impossibile elaborare la richiesta. Riprova più tardi.",
          "es-es":
            "No se puede procesar la solicitud, vuelve a intentarlo más tarde",
          "pl-pl":
            "Nie można przetworzyć żądania, prosimy spróbować ponownie później",
          "ru-ru": "Не удалось обработать запрос. Повторите попытку позже.",
          "cs-cz": "Požadavek nelze zpracovat, zkuste to znovu později.",
          "da-dk": "Anmodningen kan ikke behandles. Prøv igen senere",
          "de-at":
            "Die Anfrage kann nicht bearbeitet werden. Bitte versuche es später noch einmal.",
          "fi-fi": "Pyyntöä ei voida käsitellä, yritä myöhemmin uudelleen",
          "fr-be":
            "Impossible de traiter la demande. Veuillez réessayer plus tard.",
          "nb-no": "Forespørselen kan ikke behandles. Prøv på nytt senere",
          "nl-nl": "Kan aanvraag niet verwerken, probeer het later opnieuw",
          "sv-se": "Det gick inte att bearbeta begäran. Försök igen senare",
          "pt-pt": "Não é possível processar o pedido, tente novamente mais tarde",
        },
        remove: {
          "en": "Remove",
          "en-gb": "Remove",
          "en-us": "Remove",
          "en_US": "Remove",
          "en-eu": "Remove",
          "en-zz": "Remove",
          "en-in": "Remove",
          "en-au": "Remove",
          "de-de": "Entfernen",
          "fr-fr": "Supprimer",
          "it-it": "Rimuovi",
          "es-es": "Quitar",
          "pl-pl": "Usuń",
          "ru-ru": "Удалить",
          "cs-cz": "Odebrat",
          "da-dk": "Fjern",
          "de-at": "Entfernen",
          "fi-fi": "Poista",
          "fr-be": "Supprimer",
          "nb-no": "Fjern",
          "nl-nl": "Verwijderen",
          "sv-se": "Ta bort",
          "pt-pt": "Remover",
        },
        included: {
          "en": "Included",
          "en-gb": "Included",
          "en-us": "Included",
          "en_US": "Included",
          "en-eu": "Included",
          "en-zz": "Included",
          "en-in": "Included",
          "en-au": "Included",
          "de-de": "IM LIEFERUMFANG ENTHALTEN",
          "fr-fr": "INCLUS",
          "it-it": "INCLUSO",
          "es-es": "INCLUIDO",
          "pl-pl": "DOSTĘPNA W RAMACH SUBSKRYPCJI",
          "ru-ru": "В ПОДАРОК",
          "cs-cz": "PŘEDPLATNÉ ZAHRNUJE",
          "da-dk": "MEDFØLGER",
          "de-at": "IM LIEFERUMFANG ENTHALTEN",
          "fi-fi": "SISÄLTYY",
          "fr-be": "INCLUS",
          "nb-no": "INKLUDERT",
          "nl-nl": "INBEGREPEN",
          "sv-se": "INKLUDERAS",
          "pt-pt": "Incluído",
        },
        productLimitReached: {
          "en": "Product limit {x} reached",
          "en-gb": "Product limit {x} reached",
          "en-us": "Product limit {x} reached",
          "en_US": "Product limit {x} reached",
          "en-eu": "Product limit {x} reached",
          "en-zz": "Product limit {x} reached",
          "en-in": "Product limit {x} reached",
          "en-au": "Product limit {x} reached",
          "de-de": "Produktlimit von {x} erreicht",
          "fr-fr": "Limite de {x} produits atteinte",
          "it-it": "Limite di {x} prodotti raggiunto",
          "es-es": "Se ha alcanzado el límite de {x} productos",
          "pl-pl": "Osiągnięto limit {x} produktów",
          "ru-ru": "Не более {x} шт в заказе",
          "cs-cz": "Dosáhli jste limitu {x} produktů",
          "da-dk": "Produktgrænse på {x} er nået",
          "de-at": "Produktlimit von {x} erreicht",
          "fi-fi": "Tuotteita on jo ostettu enimmäismäärä ({x})",
          "fr-be": "Limite de {x} produits atteinte",
          "nb-no": "Produktgrensen på {x} produkter er nådd",
          "nl-nl": "Productlimiet van {x} bereikt",
          "sv-se": "Produktgräns på {x} är nådd",
          "pt-pt": "Limite do produto de {x} atingido",
        },
        productAvailabilityReached: {
          "en": "Inventory limit reached",
          "en-gb": "Inventory limit reached",
          "en-us": "Inventory limit reached",
          "en_US": "Inventory limit reached",
          "en-eu": "Inventory limit reached",
          "en-zz": "Inventory limit reached",
          "en-in": "Inventory limit reached",
          "en-au": "Inventory limit reached",
          "de-de": "Produktlimit von 2 erreicht",
          "fr-fr": "Limite de {x} produits atteinte",
          "it-it": "Limite di {x} prodotti raggiunto",
          "es-es": "Se ha alcanzado el límite de {x} productos",
          "pl-pl": "Osiągnięto limit {x} produktów",
          "ru-ru": "Достигнут лимит заказа",
          "cs-cz": "Dosáhli jste limitu {x} produktů",
          "da-dk": "Produktgrænse på {x} er nået",
          "de-at": "Produktlimit von {x} erreicht",
          "fi-fi": "Tuotteita on jo ostettu enimmäismäärä ({x})",
          "fr-be": "Limite de {x} produits atteinte",
          "nb-no": "Produktgrensen på {x} produkter er nådd",
          "nl-nl": "Productlimiet van {x} bereikt",
          "sv-se": "Produktgräns på {x} är nådd",
          "pt-pt": "Limite do inventário atingido",
        },
        giftCardProductLimitReached: {
          "en": "Membership Cards are limited to {x} per order",
          "en-gb": "Membership Cards are limited to {x} per order",
          "en-us": "Membership Cards are limited to {x} per order",
          "en_US": "Membership Cards are limited to {x} per order",
          "en-eu": "Membership Cards are limited to {x} per order",
          "en-zz": "Membership Cards are limited to {x} per order",
          "en-in": "Membership Cards are limited to {x} per order",
          "en-au": "Membership Cards are limited to {x} per order",
          "de-de": "Mitgliedschaftskarten sind auf {x} pro Bestellung begrenzt",
          "fr-fr": "Les cartes d'abonnement sont limitées à {x} par commande",
          "it-it": "Le carte di abbonamento sono limitate a {x} per ordine",
          "es-es": "Las tarjetas de suscripción están limitadas a {x} por pedido",
          "pl-pl":
            "Liczba kart z subskrypcją jest ograniczona do jednej na zamówienie",
          "ru-ru": "Достигнут лимит заказа",
          "cs-cz": "V každé objednávce může být pouze {x} karta s členstvím",
          "da-dk": "Medlemskabskort er begrænset til {x} pr. ordre",
          "de-at": "Mitgliedschaftskarten sind auf {x} pro Bestellung begrenzt",
          "fi-fi": "Jäsenyyskorttien määräksi on rajoitettu {x} per tilaus",
          "fr-be": "Limite de {x} produits atteinte",
          "nb-no": "Medlemskapskortene er begrenset til ett kort per bestilling",
          "nl-nl": "Lidmaatschapskaarten zijn beperkt tot {x} per bestelling",
          "sv-se": "Medlemskort är begränsade till en per beställning",
          "pt-pt": "Limite do inventário atingido",
        },
        mixedCartMessage: {
          "en": "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en-gb":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en-us":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en_US":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en-eu":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en-zz":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en-in":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "en-au":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "de-de":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "fr-fr":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "it-it":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "es-es":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "pl-pl":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "ru-ru":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "cs-cz":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "da-dk":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "de-at":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "fi-fi":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "fr-be":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "nb-no":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "nl-nl":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "sv-se":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
          "pt-pt":
            "NOTE: Physical and Digital Cards cannot be combined. One or more of your items will be removed.",
        },
        updatedQuantity: {
          "en": "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en-gb":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en-us":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en_US":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en-eu":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en-zz":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en-in":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "en-au":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "de-de":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "fr-fr":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "it-it":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "es-es":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "pl-pl":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "ru-ru":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "cs-cz":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "da-dk":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "de-at":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "fi-fi":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "fr-be":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "nb-no":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "nl-nl":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "sv-se":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
          "pt-pt":
            "NOTE: The digital GFN gift card(s) will be removed, as it cannot be combined with hardware products.",
        },
        limitPerCustomer: {
          "en": "Limit {x} per customer",
          "en-gb": "Limit {x} per customer",
          "en-zz": "Limit {x} per customer",
          "en-us": "Limit {x} per customer",
          "en_US": "Limit {x} per customer",
          "en-eu": "Limit {x} per customer",
          "en-in": "Limit {x} per customer",
          "en-au": "Limit {x} per customer",
          "de-de": "Max. {x} pro Kunde",
          "fr-fr": "Limite : {x} par client.",
          "it-it": "Limite di {x} per cliente",
          "es-es": "Límite de {x} por cliente",
          "pl-pl": "Obowiązuje limit {x} produktów na osobę",
          "ru-ru": "Не более {x} шт в заказе.",
          "cs-cz": "Platí omezení {x} kusy na zákazníka.",
          "da-dk": "Maks. {x} pr. kunde",
          "de-at": "Max. {x} pro Kunde",
          "fi-fi": "Enintään {x} asiakasta kohti.",
          "fr-be": "Limite : {x} par client.",
          "nb-no": "Begrenset til {x} per kunde",
          "nl-nl": "Maximaal {x} per klant",
          "sv-se": "Begränsat till {x} per kund",
          "pt-pt": "Limite de {x} por cliente",
        },
        freeShipping: {
          "en": "Free Shipping",
          "en-gb": "Free Shipping",
          "en-zz": "Free Shipping",
          "en-us": "Free Shipping",
          "en_US": "Free Shipping",
          "en-eu": "Free Shipping",
          "en-in": "Free Shipping",
          "en-au": "Free Shipping + GST Included",
          "de-de": "Kostenloser Versand",
          "fr-fr": "Livraison gratuite",
          "it-it": "Spedizione gratuita",
          "es-es": "Envío gratuito",
          "pl-pl": "Bezpłatna wysyłka",
          "ru-ru": "Бесплатная доставка по России",
          "cs-cz": "Doprava zdarma",
          "da-dk": "Gratis levering",
          "de-at": "Kostenloser Versand",
          "fi-fi": "Ilmainen toimitus",
          "fr-be": "Livraison gratuite",
          "nb-no": "Gratis frakt",
          "nl-nl": "Gratis verzending",
          "sv-se": "Fri frakt",
          "pt-pt": "Porte pago",
        },
        emailMeWhenStock: {
          "en": "Email me when in stock",
          "en-gb": "Email me when in stock",
          "en-zz": "Email me when in stock",
          "en-us": "Email me when in stock",
          "en_US": "Email me when in stock",
          "en-eu": "Email me when in stock",
          "en-in": "Email me when in stock",
          "en-au": "Email me when in stock",
          "de-de": "Mich per E-Mail benachrichtigen, wenn vorrätig",
          "fr-fr": "Prévenez-moi de la disponibilité par e-mail",
          "it-it": "Ricevi notifica di disponibilità",
          "es-es": "Envíame un correo electrónico cuando esté en stock",
          "pl-pl": "Powiadom mnie drogą mailową, gdy produkt będzie dostępny",
          "ru-ru": "Сообщите мне, когда товар появится в наличии",
          "cs-cz": "Pošlete mi e-mail, až bude skladem",
          "da-dk": "Send en e-mail til mig, når varen er på lager",
          "de-at": "Mich per E-Mail benachrichtigen, wenn vorrätig",
          "fi-fi": "Lähettäkää sähköposti, kun tuotetta tulee varastoon",
          "fr-be": "Prévenez-moi de la disponibilité par e-mail",
          "nb-no": "Send meg e-post når produktet er på lager",
          "nl-nl": "E-mail mij wanneer het op voorraad is",
          "sv-se": "Skicka ett e-postmeddelande till mig när varan finns i lager",
          "pt-pt": "Enviar-me um e-mail quando existir em stock",
        },
      }
    };